<template>
    <div class="field__multi position--relative" ref="parent">
        <input
            type="text"
            v-bind="$attrs"
            :class="[
                'field__multi__input multi--drop position--relative',
                targetClass,
                ...( !allowFilling && 'field__multi__input--disable' )
            ]"
            v-model="model"
            @click="openDrop"
            @keyup.down.prevent="pressArrowDown"
            @keyup.up.prevent="pressArrowUp"
            @keydown.enter.prevent="pressEnter"
        >
        <icon-drop-arrow
            class="field__autocomplete__arrow position--absolute pointer"
            :class="{ 'field__autocomplete__arrow--active': isOpen }"
            @click.native="toggle"
        />
        <div
            :class="[
                'field__multi__options field__autocomplete__options field__drop position--absolute multi--drop',
                allowFilling ? 'background--grey--light' : 'background--white',
                isOpen ? 'field__autocomplete__options--active' : ''
            ]"
        >
            <ul
                class="field__multi__options__content"
                :class="{ 'field__scroll scroll': filterFields.length > 5 }"
            >
                <li
                    v-if="ordering"
                    class="field__multi__option field__drop__option multi--drop position--relative">
                    {{ $t('global.loading') }}
                    <dot />
                </li>
                <li
                    v-else-if="noResults"
                    class="field__multi__option field__drop__option">{{ $t('global.noResults') }}</li>
                <li
                    v-else
                    v-for="( field, index) in filterFields"
                    class="field__multi__option field__drop__option multi--drop pointer"
                    :class="{ 'js--active': index ===  selectedOption }"
                    :key="index"
                >
                    <input
                        type="checkbox"
                        :name="`option-${index}`"
                        :id="`option-${index}`"
                        v-model="optionsList"
                        :value="field.value"
                        class="field__checkbox__input display--none"
                        v-bind="{
                            ...( !allowFilling && { disabled: 'disabled' })
                        }"
                    />
                    <label :for="`option-${index}`"
                        :class="[
                            'field__checkbox position--relative display--block',
                            { 'pointer': allowFilling }
                        ]"
                    >
                        <span
                            :class="[
                                'field__checkbox__icon multi--drop display--inline-b position--absolute',
                                allowFilling ? 'background--white' : 'background--grey--light'
                            ]"
                            aria-hidden="true"
                            :aria-label="$t('accessibility.arrow')"></span>
                        {{ field.label }}
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
// packages
import {
    reactive,
    toRefs,
    watch,
    ref,
    onMounted,
    onUnmounted
} from '@vue/composition-api';

// hooks
import { baseProps, behavior } from '@/hooks/use-drop';
import { reset } from '@/hooks/use-input-listeners';

export default {
    inheritAttrs: false,
    components: {
        Dot: () => import( /* webpackChunkName: 'Dot' */ '@/components/bundles/loadings/Dot' ),
        IconDropArrow: () => import( /* webpackChunkName: 'IconDropArrow' */ '@/components/bundles/layout/images/icons/IconDropArrow' )
    },
    props: {
        ...baseProps,
        defaultValue: Array,
        reset: Boolean,
        isEditPage: Boolean,
        isCampaignList: Boolean,
        allowFilling: {
            type: Boolean,
            default: true
        }
    },
    setup ( props, { emit }) {
        const state = reactive({
            parent: null,
            fields: props.data,
            model: '',
            optionsList: [],
            selectedOption: -1
        });
        // listener para quando for necessário
        // proceder a um reset a input.
        reset({ props, object: state, key: 'optionsList' });

        // toggle do autocomplete
        const isOpen = ref( false );

        const toggle = () => {
            isOpen.value = !isOpen.value;
            state.model = '';
            state.value = '';
        };

        const openDrop = () => {
            isOpen.value = true;
            state.model = '';
            state.value = '';
        };

        const closeDrop = () => {
            isOpen.value = false;
            state.selectedOption = -1;
        };

        // handler on click outside autocomplete
        const handleClickOutside = event => {
            if ( !state.parent.contains( event.target ) && isOpen.value )
                closeDrop();
        };

        onMounted( () => {
            document.addEventListener( 'click', handleClickOutside );
        });

        onUnmounted( () => {
            document.removeEventListener( 'click', handleClickOutside );
        });
        // seleção da opção através da tecla `enter`.
        const pressEnter = () => {
            const input = state.parent.querySelector( '.js--active > .field__checkbox__input' );
            input.checked = !input.checked;
        };

        // emissão dos utilizadores selecionados.
        watch( () => state.optionsList,
            newOptions => {
                // caso o array fique vazio, é necessário apagar
                // na store.
                const value = newOptions.length || props.isEditPage ? newOptions : '';
                emit( 'input', value );
            });

        return {
            ...toRefs( state ),
            ...behavior( props, state ),
            pressEnter,
            isOpen,
            toggle,
            openDrop
        };
    }
};
</script>
<style lang="scss">
    .field{
        &__multi{
            &__options.multi--drop{
                top: 0;
            }
            &__input.multi--drop{
                z-index: 3;
            }
        }
        &__drop{
            &__option.multi--drop{
                @include typography-specs( 15px, 20px, 200 );
            }
        }
        &__checkbox{
            &__icon.multi--drop{
                top: 3px;
            }
        }
    }

</style>